import React from 'react';

import { Checkbox } from 'semantic-ui-react';
import FieldWrapper from './fieldWrapper';

class CheckboxField extends React.Component {

    render() {
        const { checked, inputLabel, onChange, inputSub, label, id } = this.props;

        return (
            <FieldWrapper inputSub={inputSub}
                label={label}>
                <Checkbox
                    id={id}
                    label={inputLabel}
                    checked={checked}
                    onChange={onChange} />
            </FieldWrapper>
        );
    }
}

export default CheckboxField;